import { useEffect } from 'react';
import { PdfHighlighterEntity } from '../interface/pdf-pin';
import { distanceToSegment } from '../pages/pdf-pin-design/utils/pdf-pin.shared';


interface UseCanvasHoverCursorProps {
    canvasRef: React.RefObject<HTMLCanvasElement>;
    highlights: PdfHighlighterEntity[];
    isHighlightsActive: boolean;
    isMoveActive: boolean;
}


export const useCanvasHoverCursor = ({ canvasRef, highlights, isHighlightsActive, isMoveActive }: UseCanvasHoverCursorProps) => {
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const handleMouseMove = (e: MouseEvent) => {
            if (isHighlightsActive) {
                canvas.style.cursor = 'crosshair';
                return;
            }

            const rect = canvas.getBoundingClientRect();
            const mouseX = e.clientX - rect.left;
            const mouseY = e.clientY - rect.top;

            const isHoveringHighlight = highlights.some((highlight) => {
                if (highlight.isDraft) return false;
                const pts = highlight.points.filter(p => p.x != null && p.y != null);
                if (pts.length < 2) return false;

                for (let i = 0; i < pts.length - 1; i++) {
                    const x1 = (pts[i].x / 100) * rect.width;
                    const y1 = (pts[i].y / 100) * rect.height;
                    const x2 = (pts[i + 1].x / 100) * rect.width;
                    const y2 = (pts[i + 1].y / 100) * rect.height;

                    if (distanceToSegment({ x: mouseX, y: mouseY }, { x: x1, y: y1 }, { x: x2, y: y2 }) <= 5) {
                        return true;
                    }
                }
                return false;
            });

            if (!isMoveActive) {
                canvas.style.setProperty("cursor", isHoveringHighlight ? "pointer" : "default", "important");
            } else {
                canvas.style.removeProperty("cursor");
            }
        };

        canvas.addEventListener('mousemove', handleMouseMove);
        return () => {
            canvas.removeEventListener('mousemove', handleMouseMove);
        };
    }, [canvasRef, highlights, isHighlightsActive, isMoveActive]);
};
